
export default {
  /**
   * CONVERSATION TEST
   */
  'convTest.menu.title' : 'Conversation Test Dashboard<span>BETA</span>',
  'convTest.openDevTools' : 'Open Development Tool',
  'convTest.loading' : 'Loading...',

  'convTest.displayOptions': 'Toggle View Options',
  'convTest.displayOptions.subtext': 'Toggle the display options for the current view',
  'convTest.displayOption.enableQuestionMap' : 'Show Question Flow Map',
  'convTest.displayOption.enableAppkeys' : 'Appkeys',
  'convTest.displayOption.enablePageInfo' : 'Path & Page Details',
  'convTest.displayOption.enableProductIds' : 'Product IDs',
  'convTest.displayOption.enableProductDetails' : 'Product Details',

  'convTest.viewOptions': 'Change View',
  'convTest.viewOption.questionFlow' : 'Questions & Recommendations',
  'convTest.viewOption.allProducts' : 'Products List',

  'convTest.appkeys.question': 'Question Appkey:',
  'convTest.appkeys.answers': 'Answer Keys:',
  'convTest.appkeys.pageKey' : 'Page Key:',
  'convTest.appkeys.pathKey' : 'Path:',

  /**
   * DEVELOPMENT TOOL
   */
  'devTool.title': 'Development Tool',
  'devTool.subtitle': 'Neuro Guides',
  'devTool.nav.configureMock': 'Mock Configurations',
  'devTool.nav.configureMock.subtitle': 'Customize mock mode application configurations',
  'devTool.nav.contactFormModal': 'Contact Flow Form',
  'devTool.nav.contactFormModal.subtitle': 'Display and test the contact flow form',
  'devTool.nav.conversationTest': 'Conversation Test',
  'devTool.nav.conversationTest.subtitle': 'Opens the conversation test page in a new window for the current UUID: {uuid}',
  'devTool.nav.summary': 'Recommendations',
  'devTool.nav.summary.subtitle': 'Jump to the summary page for the current conversation',
  'devTool.nav.landing': 'Go To Beginning',
  'devTool.nav.landing.subtitle': 'Go back to the landing page for the current conversation',
  'devTool.nav.create': 'New Conversation',
  'devTool.nav.create.subtitle': 'Create a new conversation for this guide',
  'devTool.nav.remoteSessionModal': 'Remote Session Modal',
  'devTool.nav.remoteSessionModal.subtitle': 'Display and test the remote session component',
  'devTool.nav.shareViaEmailModal': 'Share Via Email',
  'devTool.nav.shareViaEmailModal.subtitle': 'Display and test the share via email feature',
  'devTool.nav.shareViaSmsModal': 'Share Via Text Message',
  'devTool.nav.shareViaSmsModal.subtitle': 'Display and test the share via SMS feature',
  'devTool.tab.guide': 'Guide Navigation',
  'devTool.tab.notes': 'Notes',
  'devTool.tab.mock' : 'Mock Utils',
  'devTool.notes.text': 'Save quick notes for the current UUID. Saved UUID notes are stored in the browser local storage and ' +
    '<red>the notes will be deleted anytime your cache is cleared.</red>',
  'devTool.notes.uuid': 'UUID:',
  'devTool.notes.note': 'Note:',
  'devTool.notes.savedNotes': 'Saved Notes / UUIDs:',
  'devTool.notes.save': 'Save',
  'devTool.notes.update': 'Update',
  'devTool.mockModeConfigModal.title': 'Configure Mock Mode Options',
  'devTool.mockModeConfigModal.saveBtn': 'Apply Configurations',
  'devTool.mockConfig.isBranchGuide': 'Guide Delivery Type:',
  'devTool.mockConfig.isBranchGuide.true': 'Branch',
  'devTool.mockConfig.isBranchGuide.false': 'Online',
  'devTool.mockConfig.isRemoteSession': 'Enable Remote Session Mode:',
  'devTool.mockConfig.isRemoteSession.true': 'Yes',
  'devTool.mockConfig.isRemoteSession.false': 'No',

  /**
   * ERROR PAGE
   */
  'errorPage.title': 'Uh oh, something went wrong!',
  'errorPage.paragraph': 'Looks like we ran into an issue. Click the button below to return back to the guide.',
  'errorPage.resetBtn': 'Return To Guide',

  /**
   * REMOTE SESSION
   */
  'remoteSession.modal.title': 'Start Remote Session',
  'remoteSession.formBody': 'To start a remote session with the customer, enter an email below. Once submitted, the customer ' +
    'will receive an email with a URL link to this conversation.',
  'remoteSession.formInput.emailAddress': 'Email Address',
  'remoteSession.formInput.emailAddress.placeholder': 'Enter an email',
  'remoteSession.created.success.title': 'Remote Session Created',
  'remoteSession.created.success.message': 'A link to this conversation has been sent to the customers email',

  /**
   * SHARE VIA EMAIL
   */
  'shareViaEmail.modal.title': 'Share Results via Email',
  'shareViaEmail.formBody': 'Enter an email below to send your product recommendations to.',
  'shareViaEmail.formInput.emailAddress': 'Email Address',
  'shareViaEmail.formInput.emailAddress.placeholder': 'Enter an email',
  'shareViaEmail.formInput.emailAddress.error.pattern': 'Please enter a valid email',
  'shareViaEmail.sent.success.title': 'Results Sent',
  'shareViaEmail.sent.success.message': 'Results have been successfully sent to the email recipient.',

  /**
   * SHARE VIA SMS
   */
  'shareViaSms.modal.title': 'Share Results via Text Message',
  'shareViaSms.formBody': 'Enter a phone number below to send your product recommendations to.',
  'shareViaSms.formInput.phoneNumber': 'Phone Number',
  'shareViaSms.formInput.phoneNumber.placeholder': '555-123-1234',
  'shareViaSms.formInput.phoneNumber.error.validate': 'Please enter a valid phone number',
  'shareViaSms.sent.success.title': 'Results Sent',
  'shareViaSms.sent.success.message': 'Results have been successfully sent to the text message recipient.',

  /**
   * BRANCH MENU
   */
  'branchMenu.option.newUser': 'Start New Conversation',
  'branchMenu.option.startOver': 'Go to Beginning',
  'branchMenu.logout': 'Logout',

  /**
   * CONTACT FLOW FORM
   */
  'contactForm.modal.title': 'Contact Form',
  'contactForm.sent.success.title': 'Contact Information Submitted',
  'contactForm.sent.success.message': 'Your information has been sent, and a banker should reach out to you soon.',
  'contactMeForm.formInput.firstName': 'First Name',
  'contactMeForm.formInput.firstName.placeholder': 'First Name',
  'contactMeForm.formInput.firstName.error': 'First Name is required',
  'contactMeForm.formInput.lastName': 'Last Name',
  'contactMeForm.formInput.lastName.placeholder': 'Last Name',
  'contactMeForm.formInput.lastName.error': 'Last Name is required',
  'contactMeForm.formInput.businessName': 'Business Name',
  'contactMeForm.formInput.businessName.placeholder': 'Business Name',
  'contactMeForm.formInput.businessName.error': 'Business Name is required',
  'contactMeForm.formInput.email': 'Email Address',
  'contactMeForm.formInput.email.placeholder': 'user@email.com',
  'contactMeForm.formInput.email.error': 'A valid email address is required',
  'contactMeForm.formInput.phone': 'Phone Number',
  'contactMeForm.formInput.phone.placeholder': '(555) 123-4567',
  'contactMeForm.formInput.phone.error': 'A valid 10-digit US phone number is required.',
  'contactMeForm.formInput.customerId': 'Customer Id Number',
  'contactMeForm.formInput.customerId.placeholder': 'Customer Id',
  'contactMeForm.formInput.customerId.error': 'A valid Customer Id is required',
  'contactMeForm.formInput.preferredTime': 'Preferred Time',
  'contactMeForm.formInput.preferredTime.placeholder': 'Please select',
  'contactMeForm.formInput.preferredTime.error': 'Please select',

  /**
   * FORMS
   */
  'formInput.validationError.isRequired': 'Required',
  'formInput.validationError.isEmail': 'Must be a valid email',
  'formInput.validationError.isPhoneNumber': 'Must be a valid phone number',
  'formInput.error.required': 'Required',
  'form.submit': 'Submit',

  /**
   * TIMEOUT
   */
  'default.timeout.title': 'isReminder',
  'default.timeout.message':
    'isIt looks like you\'ve stepped away from your computer for a few minutes.  Please click "dismiss" to continue working.  Otherwise, the application will exit in {time}',
  'default.timeout.action': 'isDismiss',

  /**
   * LOGIN
   */
  'employeeLogin.title': 'Login',
  'employeeLogin.edit': 'Edit Profile',
  'employeeLogin.login': 'Login',
  'employeeLogin.save': 'Save & Continue',
  'employeeLogin.cancel': 'Cancel',
  'employeeLogin.create': 'New Profile',

  'employeeLogin.login.header': 'Log In',
  'employeeLogin.login.subtitle': "You are almost ready. Confirm your account details, select your branch location, and click the 'Login' button.",
  'employeeLogin.login.help': "Review the details of your profile below. If you need to edit your profile, click the 'Edit Profile' button below. Once you confirm that all your information is correct, click the 'Login' button.",
  'employeeLogin.login.branchList': 'Select which branch you would like to log in with:',
  'employeeLogin.login.branchList.alert': 'You must select a branch before you log in.',

  'employeeLogin.edit.header': 'Edit Your Profile',
  'employeeLogin.edit.subtitle': "Enter your information and select branches for your account. When you are finished, click the 'Save & Continue' button.",

  'employeeLogin.branches.search.label': 'Search for branches:',
  'employeeLogin.branches.search.placeholder': 'Start typing to search...',
  'employeeLogin.branches.search.help': 'Results from the branch search will be shown here.',
  'employeeLogin.branches.search.empty': 'No branches were found. Please try another search.',
  'employeeLogin.branches.assigned': 'Associated Branches:',
  'employeeLogin.branches.assigned.help': "No branches associated with this profile. Use the 'search for branch' section above to search and add a branch.",
  'employeeLogin.branches.assigned.error': 'At least one branch association is required.',

  'employeeLogin.formInput.firstName': 'First Name:',
  'employeeLogin.formInput.firstName.placeholder': 'First Name',
  'employeeLogin.formInput.firstName.error': 'Invalid first name',
  'employeeLogin.formInput.lastName': 'Last Name:',
  'employeeLogin.formInput.lastName.placeholder': 'Last Name',
  'employeeLogin.formInput.lastName.error': 'Invalid last name',
  'employeeLogin.formInput.email': 'Email:',
  'employeeLogin.formInput.email.placeholder': 'user@email.com',
  'employeeLogin.formInput.email.error': 'Invalid email',
  'employeeLogin.formInput.phone': 'Phone Number:',
  'employeeLogin.formInput.phone.placeholder': '(555) 123-4567',
  'employeeLogin.formInput.phone.error': 'Invalid phone #',
  'employeeLogin.formInput.employeeId': 'Employee ID:',
  'employeeLogin.formInput.employeeId.placeholder': 'Employee ID',
  'employeeLogin.formInput.employeeId.error': 'Invalid ID',
  'employeeLogin.formInput.nmlsId': 'NMLS ID Number:',
  'employeeLogin.formInput.nmlsId.placeholder': 'NMLS #',
  'employeeLogin.formInput.nmlsId.error': 'Enter numbers only',
  'employeeLogin.formInput.isRequired': 'Required',

  'employeeLogin.search.header': 'Select Your Profile',
  'employeeLogin.search.subtitle': 'To select your profile, you can search for a previously created account or create a new profile.',
  'employeeLogin.search': 'Search',
  'employeeLogin.search.label': 'Enter your employee id, name, email address, or phone number to search for your profile:',
  'employeeLogin.search.placeholder': 'Search for profile',
  'employeeLogin.search.results.empty': 'No results found.  Search again or click "New Profile" below to create a profile.',
  'employeeLogin.search.results.description': 'Click a profile to log in',
  'employeeLogin.search.empty': 'No results found. Search again or click the "New Profile" button below to create a account.',

  'employeeLogin.conflicts': 'Profile(s) have been found that conflict with fields entered above:',

  'employeeLogin.flowStep.profile': 'Choose your profile',
  'employeeLogin.flowStep.branch': 'Select a branch',
  'employeeLogin.flowStep.login': 'Log in',

  /**
   * VALIDATION ERRORS
   */
  'validationErrors.error.title': 'Validation Errors',
  'error.title': 'Errors',
  'error.question.required': 'Must be answered',
  'error.question.between': 'Value must be between {0} and {1}',
  'error.question.zipCode': 'Must enter a valid zip code',
  'error.question.postalCode': 'Must enter a valid zip code', //TODO: investigate the differences between local validation and server validation (postal vs zip)
  'error.question.outOfFootprint': 'The zip code you entered is not within service',
  'error.questionGroup.required': 'You must answer a question',
  'error.questionGroup.between': 'Total value must be between {0} and {1}',
  'error.questionGroup.equal': 'Total value must equal to {0}',

  /*
   * NAVIGATION
   */
  'nav.prev': 'Go Back',
  'nav.next': 'Next',

  /*
   * GENERAL
   */
  'pleaseSelect': 'Select an option',
  'editAnswer': 'Edit Answer',
};
